import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "flag",
  "use": "flag-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"flag\"><title>flag</title><path d=\"M6 4.563l13.035 3.666c.533.15.965.72.965 1.27v1.002c0 .552-.428 1.12-.965 1.27L6 15.437v5.564A.997.997 0 0 1 5 22c-.552 0-1-.446-1-.999V3A.997.997 0 0 1 5 2c.552 0 1 .446 1 .999v1.563zm0 2.089l.017 6.703L18 10.003 6 6.652z\" fill-rule=\"nonzero\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol